import { cx } from "@emotion/css";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { TextButton } from "src/components/Default/LekUI/Button";
import type { AnimateExitFn } from "./Flashcard";

interface ViewControllerProps {
	animateExit: AnimateExitFn;
	onPrevious: () => void;
	onNext: () => void;
}

export function ViewController({
	animateExit,
	onPrevious,
	onNext,
}: ViewControllerProps) {
	const { t } = useTranslation();

	return (
		<div className="flashcard-app--controller">
			<TextButton
				onClick={() => animateExit("left", "blue", onPrevious)}
				className={cx("primary-important-text-btn", "flashcard-app--option")}
				data-test-id="flashcard-view-previous-button"
			>
				<span className="flashcard-app--option-label">
					<ArrowLeft className="icon-super-small" />
					{t("decks.view.previous", "Poprzednia")}
				</span>
			</TextButton>
			<TextButton
				onClick={() => animateExit("right", "blue", onNext)}
				className={cx("primary-important-text-btn", "flashcard-app--option")}
				data-test-id="flashcard-view-next-button"
			>
				<span className="flashcard-app--option-label">
					<ArrowRight className="icon-super-small" />
					{t("decks.view.next", "Następna")}
				</span>
			</TextButton>
		</div>
	);
}
